import { ForkKnife, Drop, UsersThree } from "@phosphor-icons/react";

const MEALS_IMG = "https://images.pexels.com/photos/18855635/pexels-photo-18855635.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const COMMUNITY_IMG = "https://images.unsplash.com/photo-1578515637272-e4afe0b8ec82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHx3YXJtJTIwaG9tZSUyMGNvb2tlZCUyMG1lYWwlMjBoYW5kc3xlbnwwfHx8fDE3ODAwODU1ODF8MA&ixlib=rb-4.1.0&q=85";

export default function WhatWeOffer() {
  return (
    <section id="offer" data-testid="what-we-offer" className="py-24 md:py-32 bg-[#F4EFE6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <p className="label-eyebrow mb-5">What We Offer</p>
          <h2 className="font-headline font-light text-4xl md:text-5xl text-[#1F1A17] leading-tight">
            Three things, given freely, <span className="italic text-[#C25934]">every evening we're open</span>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-6">
          {/* Large card - Meals */}
          <div
            data-testid="offer-meals"
            className="md:col-span-4 md:row-span-2 group relative rounded-3xl overflow-hidden border border-[#EADAB9] bg-[#FDFBF7] min-h-[420px]"
          >
            <img
              src={MEALS_IMG}
              alt="A freshly cooked meal"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1F1A17]/85 via-[#1F1A17]/30 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8 md:p-10 text-white">
              <ForkKnife size={36} weight="duotone" className="mb-4 text-[#EADAB9]" />
              <h3 className="font-headline text-3xl md:text-4xl font-medium">
                Freshly cooked meals
              </h3>
              <p className="mt-3 text-white/85 max-w-md leading-relaxed">
                A real meal, made with care — the kind of food that says you matter, you're
                welcome here, pull up a seat and stay awhile.
              </p>
            </div>
          </div>

          {/* Hygiene Supplies */}
          <div
            data-testid="offer-hygiene"
            className="md:col-span-2 rounded-3xl border border-[#EADAB9] bg-[#FDFBF7] p-8 md:p-10 flex flex-col justify-between min-h-[200px]"
          >
            <div>
              <Drop size={36} weight="duotone" className="text-[#C25934] mb-4" />
              <h3 className="font-headline text-2xl md:text-3xl font-medium text-[#1F1A17]">
                Hygiene supplies
              </h3>
              <p className="mt-3 text-[#5A524A] leading-relaxed">
                Soap, toothbrushes, razors, socks, warm hats. The small things that quietly
                restore dignity.
              </p>
            </div>
          </div>

          {/* Community */}
          <div
            data-testid="offer-community"
            className="md:col-span-2 group relative rounded-3xl overflow-hidden border border-[#EADAB9] min-h-[200px]"
          >
            <img
              src={COMMUNITY_IMG}
              alt="Hands sharing food in community"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#5C6B51]/90 via-[#5C6B51]/40 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8 text-white">
              <UsersThree size={32} weight="duotone" className="mb-3 text-white/80" />
              <h3 className="font-headline text-2xl md:text-3xl font-medium">
                Community support
              </h3>
              <p className="mt-2 text-white/85 text-sm md:text-base leading-relaxed">
                Conversation, connection, & a steady welcome.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
